import React from 'react'
import { Paper, Badge, Button, IconButton, Avatar, Toolbar } from 'material-ui';
import DeleteIcon from 'material-ui-icons/Delete';
import List, {
    ListItem,
    ListItemAvatar,
    ListItemSecondaryAction,
    ListItemText,
} from 'material-ui/List';
import { findDOMNode } from 'react-dom';
import PriorityHigh from 'material-ui-icons/PriorityHigh'
import { Popover, Typography } from 'material-ui';
import NotificationIcon from 'material-ui-icons/Notifications'

class CustomNotifcationPopover extends React.Component {

    handleNotifClick = () => {
        this.setState({
            open: true,
            anchorEl: findDOMNode(this.button),
        });
    }

    handleRequestClose = () => {
        this.setState({
            open: false,
        });
    };


    constructor(props) {
        super(props)
        this.state = {
            open: false,
            anchorEl: null,
            anchorOriginVertical: 'bottom',
            anchorOriginHorizontal: 'center',
            transformOriginVertical: 'top',
            transformOriginHorizontal: 'center',
            positionTop: 200, // Just so the popover can be spotted more easily
            positionLeft: 400, // Same as above
            anchorReference: 'anchorEl',
        };
    }
    render() {
        const {
            open,
            anchorEl,
            anchorOriginVertical,
            anchorOriginHorizontal,
            transformOriginVertical,
            transformOriginHorizontal,
            positionTop,
            positionLeft,
            anchorReference,
          } = this.state;
        return (
            <div>
                <Badge badgeContent={2} color="accent">

                <IconButton
                    ref={node => {
                        this.button = node;
                    }}
                    className="notif-icon"
                    onClick={this.handleNotifClick}
                >
                    <NotificationIcon />
                </IconButton>
                </Badge>
                <Popover
                    open={open}
                    anchorEl={anchorEl}
                    anchorReference={anchorReference}
                    anchorPosition={{ top: positionTop, left: positionLeft }}
                    onRequestClose={this.handleRequestClose}
                    anchorOrigin={{
                        vertical: anchorOriginVertical,
                        horizontal: anchorOriginHorizontal,
                    }}
                    transformOrigin={{
                        vertical: transformOriginVertical,
                        horizontal: transformOriginHorizontal,
                    }}
                >
                    <Paper className="es">
                        <div className="box notification-box">
                            <div className={"colored-header small"}>
                                <h2>Notifications</h2>
                            </div>
                            <List>
                                <ListItem button>
                                    <ListItemAvatar>
                                        <Avatar>
                                            <PriorityHigh />
                                        </Avatar>
                                    </ListItemAvatar>
                                    <ListItemText primary="You received a new notification from Henriette Boyer" />
                                    <ListItemSecondaryAction>
                                        <IconButton aria-label="Delete">
                                            <DeleteIcon />
                                        </IconButton>
                                    </ListItemSecondaryAction>
                                </ListItem>
                                <ListItem button>
                                    <ListItemAvatar>
                                        <Avatar>
                                            <PriorityHigh />
                                        </Avatar>
                                    </ListItemAvatar>
                                    <ListItemText primary="Dr send you a new graph" />
                                    <ListItemSecondaryAction>
                                        <IconButton aria-label="Delete">
                                            <DeleteIcon />
                                        </IconButton>
                                    </ListItemSecondaryAction>
                                </ListItem>
                            </List>
                        </div>
                    </Paper>
                </Popover>
            </div>)
    }
}

export default CustomNotifcationPopover


// WEBPACK FOOTER //
// ./src/components/CustomNotificationPopover.js